var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',[_c('div',{staticClass:"modal",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{staticClass:"modal-image",attrs:{"src":_vm.url,"alt":_vm.title}})])])}
var staticRenderFns = []

export { render, staticRenderFns }